import { useEffect } from 'react'

import { useToast } from '@asad/crane-ui'

type ToastApi = ReturnType<typeof useToast>

let api: ToastApi | null = null

export const ToastBridge = () => {
  const toast = useToast()

  useEffect(() => {
    api = toast
    return () => {
      api = null
    }
  }, [toast])

  return null
}

/** Wyłącznie dla kodu poza Reactem (middleware, thunk). W komponencie i hooku użyj `useToast` —
 *  `notify` milcząco gubi komunikat, dopóki `ToastBridge` nie jest zamontowany. */
export const notify = {
  success: (message: string) => api?.success(message),
  error: (message: string) => api?.error(message),
  warning: (message: string) => api?.warning(message),
}
